import React from 'react';
import { Activity } from 'botframework-directlinejs';

import { EVENT_NAME_ENGAGE_TROUBLESHOOTER } from '../../utils';

/**
 * Gets the React key prop for an activity. This is usually the activity.id except in cases like streaming message from bot, where we want to keep the
 * same key so that the component does not get unmounted and remounted.
 * @param activity {Activity} - Activity to get the key for.
 * @returns {React.Key} - React key prop for list item.
 */
export function getActivityKey(activity: Activity): React.Key | undefined {
  if (activity.type === 'message') {
    const replyToId = (activity as any)?.replyToId;
    if (replyToId) {
      const isStaticMessage = (activity as any)?.text === 'StaticMessages';
      const isAnimationCard = (activity as any)?.value === 'AnimationCard';

      if (!isAnimationCard && !isStaticMessage) {
        return `reply-message-${replyToId}`;
      }
    }
  } else if (activity.type === 'event' && activity.name === EVENT_NAME_ENGAGE_TROUBLESHOOTER) {
    // for ad delivery troubleshooting, each activity is a new message
    // it need to be handled separately
    return activity.id;
  }

  return activity.id;
}
